<ng-template [ngIf]="!errorCode" [ngIfElse]="error">
    <router-outlet></router-outlet>
</ng-template>
<ng-template #error>
    <app-error></app-error>
</ng-template>

<div *ngIf="showFullSpinner" class="full-page-spinner">
    <div></div>
    <app-spinner [show]="true" [showOverContent]="true"></app-spinner>
</div>
